module.exports = __webpack_public_path__ + "static/media/alligator_strap_brown.04d57c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alligator_strap_brown.png
// module id = 102
// module chunks = 0